import { countObject } from "@/types/tasksInterface";

import complaintApi from "@/api/complaintApi";
import taskApi from "@/api/taskApi";
import aberrationApi from "@/api/aberrationApi";
import checkListApi from "@/api/checkListApi";

export async function count(
  profileId: number,
  isTrysilhus: boolean,
  projectId: string | null = null,
  houseId: string | null = null
) {
  const data = {
    enquiry: 0,
    complaints: 0,
    checkups: 0,
    actions: 0,
    checklists: 0,
  } as countObject;

  const headersEnquiry = [
    {
      text: "isEnquiry",
      value: "isEnquiry",
      type: "boolean",
      show: false,
      filterValues: ["true"],
      filterClause: 0,
      filterName: "isEnquiry",
      removeFilter: true,
    },
    {
      text: "Status",
      value: "regStatus",
      type: "int",
      show: true,
      filterValues: [0, 1, 4, 6, 7],
      filterClause: 0,
      filterName: "lineStatus",
      sortable: false,
    },
    {
      text: "Ansvarlig",
      value: "contactPersonName",
      type: "string",
      show: true,
      filterValues: [profileId],
      filterClause: 0,
      filterName: "contactPersonOid",
    },
    {
      filterName: "projectOid",
      filterValues: projectId ? [projectId] : "",
      show: true,
      type: "string",
    },
    {
      filterName: "houseOid",
      filterValues: houseId ? [houseId] : "",
      show: true,
      type: "string",
    },
  ];

  const headersComplaints = [
    {
      text: "isEnquiry",
      value: "isEnquiry",
      type: "boolean",
      show: false,
      filterValues: ["false"],
      filterClause: 0,
      filterName: "isEnquiry",
      removeFilter: true,
    },
    {
      text: "Status",
      value: "regStatus",
      type: "int",
      show: true,
      filterValues: [0, 1, 4, 6, 7],
      filterClause: 0,
      filterName: "lineStatus",
      sortable: false,
    },
    {
      text: "Ansvarlig",
      value: "contactPersonName",
      type: "string",
      show: true,
      filterValues: [profileId],
      filterClause: 0,
      filterName: "contactPersonOid",
    },
    {
      filterName: "projectOid",
      filterValues: projectId ? [projectId] : "",
      show: true,
      type: "string",
    },
    {
      filterName: "houseOid",
      filterValues: houseId ? [houseId] : "",
      show: true,
      type: "string",
    },
  ];

  const headersCheckups = [
    {
      text: "Type",
      value: "taskType",
      type: "string",
      show: false,
      filterValues: ["2"],
      filterClause: 0,
      filterName: "taskType",
      removeFilter: true,
    },
    {
      text: "Ferdigmeld",
      value: "isCompleted",
      type: "boolean",
      show: true,
      filterValues: ["false"],
      filterClause: 0,
      filterName: "isCompleted",
    },
    {
      text: "Ansvarlig",
      value: "assignedTo",
      type: "string",
      show: true,
      filterValues: [profileId],
      filterClause: 0,
      filterName: "assignedToId",
    },
    {
      filterName: "projectId",
      filterValues: projectId ? [projectId] : "",
      show: true,
      type: "string",
    },
    {
      filterName: "houseId",
      filterValues: houseId ? [houseId] : "",
      show: true,
      type: "string",
    },
  ];

  const headersActions = [
    {
      text: "Status",
      value: "statusText",
      type: "string",
      show: true,
      filterValues: [1],
      filterClause: 0,
      filterName: "actionStatus",
      sortIndex: 2,
    },
    {
      text: "Ansvarlig",
      value: "responsible",
      type: "string",
      show: true,
      filterValues: [profileId],
      filterClause: 0,
      filterName: "responsibleId",
    },
    {
      filterName: "projTable",
      filterValues: projectId ? [projectId] : "",
      show: true,
      type: "string",
    },
    {
      filterName: "projPhase",
      filterValues: houseId ? [houseId] : "",
      show: true,
      type: "string",
    },
  ];

  const headersChecklists = [
    {
      text: "Fullført",
      value: "isCompleted",
      type: "boolean",
      show: true,
      filterValues: ["false"],
      filterClause: 0,
      filterName: "isCompleted",
    },
    {
      text: "Ansvarlig",
      value: "assignedTo",
      type: "string",
      show: true,
      filterValues: [profileId],
      filterClause: 0,
      filterName: "assignedContactPersonId",
    },
    {
      filterName: "projTable",
      filterValues: projectId ? [projectId] : "",
      show: true,
      type: "string",
    },
    {
      filterName: "projPhase",
      filterValues: houseId ? [houseId] : "",
      show: true,
      type: "string",
    },
  ];

  data.enquiry = await complaintApi.getComplaintsCount({
    headers: headersEnquiry,
    hideLoader: true,
  });

  data.complaints = await complaintApi.getComplaintsCount({
    headers: headersComplaints,
    hideLoader: true,
  });

  data.checkups = await taskApi.getTaskCount({
    headers: headersCheckups,
    hideLoader: true,
  });

  data.actions = await aberrationApi.getActionsCount({
    headers: headersActions,
    hideLoader: true,
  });

  if (isTrysilhus) {
    data.checklists = await checkListApi.getChecklistsCount({
      headers: headersChecklists,
      hideLoader: true,
    });
  }
  return data;
}
